<app-menu>
  <div class="desktop">
    <div class="header">
      <app-titulo text="Pedidos"></app-titulo>
      <div class="header-buttons">
        <app-botao
          type="primario"
          text="Criar pedido"
          width="100%"
          icon="assets/images/add.svg"
          (click)="navigateCriarPedido()"
        ></app-botao>
      </div>
    </div>
    <div class="table-header">
      <h1 class="table-title">Listagem</h1>
      <div class="table-filters">
        <app-input
          type="search"
          placeholder="Pesquisar"
          icon="assets/images/search.svg"
          [(ngModel)]="pesquisaParams.TxPesquisar"
          (ngModelChange)="onChangeSearch()"
        ></app-input>
        <app-input
          placeholder="Data"
          type="date"
          [(ngModel)]="pesquisaParams.DtPedido"
          (ngModelChange)="onChangeSearch()"
        ></app-input>
      </div>
    </div>
    <app-tabela [data]="tableData" [columns]="tableColumns"></app-tabela>
    <app-paginacao
      [pages]="pesquisaParams.MaxPages"
      (selectedPage)="mudarPagina($event)"
    ></app-paginacao>
  </div>

  <div class="mobile">
    <app-titulo text="Suprimentos"></app-titulo>
    <div class="listagem">
      <div
        class="menu-mobile"
        (click)="this.expandirCardsMobile = !this.expandirCardsMobile"
      >
        <app-titulo class="title" text="Pedidos"></app-titulo>
        <img
          *ngIf="!expandirCardsMobile"
          src="assets/images/arrow-down.svg"
          class="expandir-icon"
        />
        <img
          *ngIf="expandirCardsMobile"
          src="assets/images/arrow-up.svg"
          class="expandir-icon"
        />
      </div>
      <div class="mobile-filters">
        <app-input
          type="search"
          placeholder="Pesquisar"
          icon="assets/images/search.svg"
          [(ngModel)]="pesquisaParams.TxPesquisar"
          (ngModelChange)="onChangeSearch()"
        ></app-input>
        <app-input
          placeholder="Data"
          type="date"
          [(ngModel)]="pesquisaParams.DtPedido"
          (ngModelChange)="onChangeSearch()"
          *ngIf="expandirCardsMobile"
        ></app-input>
        <app-botao
          type="primario"
          text="Criar pedido"
          width="100%"
          icon="assets/images/add.svg"
          (click)="navigateCriarPedido()"
        ></app-botao>
      </div>
      <app-card-mobile
        [data]="tableData"
        [rows]="rowsMobile"
        [expand]="expandirCardsMobile"
      ></app-card-mobile>
      <app-paginacao
        [pages]="pesquisaParams.MaxPages"
        (selectedPage)="mudarPagina($event)"
      ></app-paginacao>
      <!-- <app-botao
        type="secundario"
        text="Exportar Excel"
        width="100%"
        icon="assets/images/download-icon.svg"
      ></app-botao> -->
    </div>
  </div>
</app-menu>
<app-loader *ngIf="loader" />
